import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';
import { ChatHeaderActions } from './chat-header.actions';
import { selectOperatorName } from '../live-chat/live-chat.reducer';
import { Store } from '@ngrx/store';
import { getBrand } from '../../../utils/getBrand';
import { getChatHeaderLogoImage } from '../../../utils/getChatHeaderLogoImage';
import { AuthTokenActions } from '../auth-token/auth-token.actions';
import { LiveChatActions } from '../live-chat/live-chat.actions';
import { SettingsActions } from '../settings/settings.action';

@Injectable({
  providedIn: 'root',
})
export class ChatHeaderEffects {
  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private store: Store
  ) {}

  setVaHeader$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChatHeaderActions.setVaHeader, AuthTokenActions.startSession),
      map(() => {
        const title = this.translateService.instant('TITLE');
        const logo = getChatHeaderLogoImage(false, getBrand().code);
        return ChatHeaderActions.setHeader({
          value: {
            title,
            logo,
            isLiveChatHeader: false,
          },
        });
      })
    )
  );

  setVaHeaderTitle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SettingsActions.setLanguageSuccess),
      map(() => {
        const title = this.translateService.instant('TITLE');
        return ChatHeaderActions.setTitle({
          value: title,
        });
      })
    )
  );

  setLiveChatHeader$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ChatHeaderActions.setLiveChatHeader, LiveChatActions.setOperator),
      concatLatestFrom(() => this.store.select(selectOperatorName)),
      map(([, title]) => {
        const logo = getChatHeaderLogoImage(true, getBrand().code);
        return ChatHeaderActions.setHeader({
          value: {
            title,
            logo,
            isLiveChatHeader: true,
          },
        });
      })
    )
  );
}
